import React from "react"
import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import {useNavigate} from "react-router-dom";

interface StoreSearchProps {
}

export function StoreSearch({ }: StoreSearchProps) {
    const navigate = useNavigate()
    const [searchValue, setSearchValue] = useState("")

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault()
        if (searchValue.trim()) {
            navigate(`/account/${searchValue}`)
        }
    }

    return (
        <form onSubmit={handleSearch} className="flex w-full space-x-2">
            <Input
                type="text"
                placeholder="Store URL"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                className="flex-1"
            />
            <Button type="submit" className="bg-green-600 text-white hover:bg-green-700">
                View
            </Button>
        </form>
    )
}
